module.exports = __webpack_public_path__ + "static/media/snappy-mobile.2222259f.svg";